export const ALLOWED_STORAGES = ['PKCS12'];
export const EXT_KEY_USAGE_OIDS = ['1.3.6.1.5.5.7.3.4', '1.2.398.3.3.4.1.1'];
export const DIRECTOR_FIO = 'Белощицкий Андрей Александрович';
export const DIRECTOR_IIN = '';